import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const ImpersonateRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const targetPath = sessionStorage.getItem('impersonate_redirect');
    if (targetPath) {
      sessionStorage.removeItem('impersonate_redirect');
      navigate(targetPath);
    }
  }, [navigate]);

  return null;
};
